
    import './styles.scoped.css';
    export default {
  "gen-ai": "awsui_gen-ai_12y5i_35kt6_15",
  "gradientMove": "awsui_gradientMove_12y5i_35kt6_1",
  "gradientMoveReverse": "awsui_gradientMoveReverse_12y5i_35kt6_1",
  "dot": "awsui_dot_12y5i_35kt6_77",
  "dotsDancing": "awsui_dotsDancing_12y5i_35kt6_1",
  "root": "awsui_root_12y5i_35kt6_158",
  "typing": "awsui_typing_12y5i_35kt6_172"
};
  